var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calender"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    width: 15,
    height: 15,
    transform: "translate(0 -0.31)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_17",
    "data-name": "Mask Group 17",
    transform: "translate(0 0.31)",
    clipPath: "url(#calender)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_25_",
    "data-name": "svgexport-6 (25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5150",
    "data-name": "Path 5150",
    d: "M3.75.469a.47.47,0,0,0-.469.469v.469H1.875A1.41,1.41,0,0,0,.469,2.813v11.25a1.381,1.381,0,0,0,1.406,1.406H14.063a1.381,1.381,0,0,0,1.406-1.406V2.813a1.381,1.381,0,0,0-1.406-1.406H12.656V.938a.469.469,0,0,0-.937,0v.469h-7.5V.938A.443.443,0,0,0,3.75.469ZM14.531,14.063a.443.443,0,0,1-.469.469H1.875a.443.443,0,0,1-.469-.469V5.156H14.531ZM11.719,2.344v.469a.469.469,0,0,0,.938,0V2.344h1.406a.443.443,0,0,1,.469.469V4.219H1.406V2.813a.443.443,0,0,1,.469-.469H3.281v.469a.443.443,0,0,0,.469.469.443.443,0,0,0,.469-.469V2.344Z",
    transform: "translate(-0.469 -0.469)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5151",
    "data-name": "Path 5151",
    d: "M3.328,9.141H5.2a.443.443,0,0,0,.469-.469V6.8A.443.443,0,0,0,5.2,6.328H3.328a.443.443,0,0,0-.469.469V8.672A.443.443,0,0,0,3.328,9.141ZM3.8,7.266h.937V8.2H3.8Z",
    transform: "translate(-0.469 -0.469)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5152",
    "data-name": "Path 5152",
    d: "M7.078,9.141H8.953a.443.443,0,0,0,.469-.469V6.8a.443.443,0,0,0-.469-.469H7.078a.443.443,0,0,0-.469.469V8.672A.443.443,0,0,0,7.078,9.141Zm.469-1.875h.938V8.2H7.547Z",
    transform: "translate(-0.469 -0.469)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5153",
    "data-name": "Path 5153",
    d: "M10.828,9.141H12.7a.443.443,0,0,0,.469-.469V6.8a.443.443,0,0,0-.469-.469H10.828a.443.443,0,0,0-.469.469V8.672A.443.443,0,0,0,10.828,9.141ZM11.3,7.266h.938V8.2H11.3Z",
    transform: "translate(-0.469 -0.469)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5154",
    "data-name": "Path 5154",
    d: "M3.328,13.359H5.2a.443.443,0,0,0,.469-.469V11.016a.443.443,0,0,0-.469-.469H3.328a.443.443,0,0,0-.469.469v1.875A.443.443,0,0,0,3.328,13.359ZM3.8,11.484h.937v.938H3.8Z",
    transform: "translate(-0.469 -0.469)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5155",
    "data-name": "Path 5155",
    d: "M7.078,13.359H8.953a.443.443,0,0,0,.469-.469V11.016a.443.443,0,0,0-.469-.469H7.078a.443.443,0,0,0-.469.469v1.875A.443.443,0,0,0,7.078,13.359Zm.469-1.875h.938v.938H7.547Z",
    transform: "translate(-0.469 -0.469)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5156",
    "data-name": "Path 5156",
    d: "M10.828,13.359H12.7a.443.443,0,0,0,.469-.469V11.016a.443.443,0,0,0-.469-.469H10.828a.443.443,0,0,0-.469.469v1.875A.443.443,0,0,0,10.828,13.359Zm.469-1.875h.938v.938H11.3Z",
    transform: "translate(-0.469 -0.469)",
    fill: "#6a6f73"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.3b6add1c3f2866bb42bee7360415ba25.svg";
export { ForwardRef as ReactComponent };